export default "__VITE_ASSET__BLBapM8N__"